import React, { lazy } from 'react';
import { PrivateRoute } from '@/hooks/useAuth';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';

const InventoryEntry = lazy(() => import('@/containers/Views/Inventory/components/InventoryEntry'));
const InventoryPage = lazy(() => import('@/containers/Views/Inventory/InventoryPageNew'));
const IventoryWriteOff = lazy(() => import('@/containers/Views/Inventory/InventoryWriteOffPage'));
const InventoyConversionPage = lazy(() => import('@/containers/Views/InventoryConversions/InventoyConversionPage'));
const FoliosPage = lazy(() => import('@/containers/Views/Folios/FoliosPage'));

const InventoryRouter = (
  <Route path="inventory">
    <Route
      index
      element={(
        <PrivateRoute
          pageName={EPage.ProductInventories}
          permissions={EBasicActions.Find}
        >
          <InventoryPage />
        </PrivateRoute>
      )}
    />
    <Route
      path="entry"
      element={(
        <PrivateRoute
          pageName={EPage.ProductInventories}
          permissions={EBasicActions.Find}
        >
          <InventoryEntry />
        </PrivateRoute>
      )}
    />
    <Route
      path="write_off"
      element={(
        <PrivateRoute
          pageName={EPage.ProductInventories}
          permissions={EBasicActions.Find}
        >
          <IventoryWriteOff />
        </PrivateRoute>
      )}
    />
    <Route
      path="conversions"
      element={(
        <PrivateRoute
          pageName={EPage.InventoryConversions}
          permissions={EBasicActions.Find}
        >
          <InventoyConversionPage />
        </PrivateRoute>
      )}
    />
    <Route
      path="folios"
      element={(
        <PrivateRoute
          pageName={EPage.Folios}
          permissions={EBasicActions.Find}
        >
          <FoliosPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default InventoryRouter;
